/** CDD tier display metadata — shared by CddTierCard and CddTierBadge. */

export const CDD_TIERS = [
  { value: 'simplified', label: 'Simplified', color: '#166534', bg: '#dcfce7', border: '#bbf7d0',
    desc: 'Lowest intrinsic risk — minimum identity + biennial re-verification.' },
  { value: 'standard',   label: 'Standard',   color: '#1e40af', bg: '#dbeafe', border: '#bfdbfe',
    desc: 'Default for most patrons — full Initial CDD + annual re-verification.' },
  { value: 'enhanced',   label: 'Enhanced',   color: '#92400e', bg: '#fef3c7', border: '#fde68a',
    desc: 'Elevated risk — full CDD + source of funds + 6-monthly re-verification.' },
  { value: 'prohibited', label: 'Prohibited', color: '#991b1b', bg: '#fee2e2', border: '#fecaca',
    desc: 'Venue must not serve this patron — confirmed sanctions hit / internal ban.' },
]

export function cddTierMeta(tier) {
  const key = tier != null ? String(tier).trim().toLowerCase() : ''
  return CDD_TIERS.find((t) => t.value === key) || null
}
